import { createEndGameApi, EndGameService } from '@slot-nx/core'
import { gameConfig } from '../../config'

export const endGameService = new EndGameService(createEndGameApi(gameConfig.name))
